import $ from "jquery";
import { changeSceneTime, modelForExport } from "../../core/3d-configurator";
import {
  changeColorForAllScreen,
  clearClones,
  listenerChange,
  pointLights,
} from "../../core/customFunctions/customFunctions";
import {
  changeURL
} from "../../core/customFunctions/paramsURL.js";
import {
  lastHeatersForRemove,
  setAllHotspotsVisibility,
  setSpansHeaters,
  spansHeaters,
  showAvailableSpans,
  removeSingleHeater,
  updateHotspots,
  hotspots
} from "../../core/customFunctions/subSystemHeaters";
import {
  lastScreenForRemove,
  setAllHotspotsVisibilityScreen,
  setSpansScreen,
  showAvailableSpansScreen,
  getBaseSpanId,
  cleanActiveSpansArray,
} from "../../core/customFunctions/subSystemScreen";
import { state } from "../../core/settings";
import { generateRangeHTML } from "../Interface/interfaceItems/interfaceGroup/interfaceGroupInputs/range/generateRange";
import { typeSubSystem, subSystemConfig } from "../Interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs"
import "./portals.scss";

function getSubSystemElement(subsystemKey) {
  return $(`.type_interface_electronic_item[data-subsystem="${subsystemKey}"]`);
}

export const lightRange = [
  {
    title: "Spacing",
    min: 2,
    max: 8,
    step: 1,
    thumb: true,
    initialValue: state.recessedLighting,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const shadesRange = [
  {
    title: "Shades",
    min: 1,
    max: 90,
    step: 1,
    thumb: false,
    initialValue: state.defaultShadesMorph,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const typePortalOption = {
  screens: "screens",
  shades: "shades",
  light: "light",
  heaters: "heaters",
};

export function portalComponent() {
  const modelId = $("#ar_model_viewer");
  const mainContent = $("#content");

  const portalContent = $(`
    <div class="portal-light">
        <h3 class="portal-light__title">Recessed Lighting</h3>
        <span class="portal-light__close"></span>

        <div class="portal-light__range"></div>

        <span class="portal-light__remove">Remove</span>
    </div>

    <div class="portal-heaters">
        <h3 class="portal-heaters__title">Heaters</h3>
        <span class="portal-heaters__close"></span>

        <span class="portal-heaters__remove">Remove</span>
    </div>

    <div class="portal-shades">
        <h3 class="portal-shades__title">Shades</h3>
        <span class="portal-shades__close"></span>

         <div class="portal-shades__range"></div>

        <span class="portal-shades__remove">Remove</span>
    </div>

    <div class="portal-screen">
        <h3 class="portal-screen__title">Screens</h3>
        <span class="portal-screen__close"></span>

        <div class="portal-screen__block">
           <h4 class="portal-screen__block__title active" id="pattern">Pattern</h4>

           <ul class="portal-screen__block__list">
             <li class="portal-screen__block__list__item">
               <div class="portal-screen__block__list__item__container">
                 <img src="./public/img/icons-screens/Rectangle-1.svg"/>
               </div>

               <h5 class="portal-screen__block__list__item__title" data-value="Branch" id="Branch">Branch</h5>
             </li>

             <li class="portal-screen__block__list__item">
               <div class="portal-screen__block__list__item__container">
                 <img src="./public/img/icons-screens/Rectangle-2.svg"/>
               </div>

               <h5 class="portal-screen__block__list__item__title" data-value="Breeze" id="Breeze">Breeze</h5>
             </li>

             <li class="portal-screen__block__list__item">
               <div class="portal-screen__block__list__item__container">
                 <img src="./public/img/icons-screens/Rectangle-3.svg"/>
               </div>

               <h5 class="portal-screen__block__list__item__title" data-value="Dash" id="Dash">Dash</h5>
             </li>

             <li class="portal-screen__block__list__item">
               <div class="portal-screen__block__list__item__container">
                 <img src="./public/img/icons-screens/Rectangle-4.svg"/>
               </div>

               <h5 class="portal-screen__block__list__item__title" data-value=Hexx" id="Hexx">Hexx</h5>
             </li>

             <li class="portal-screen__block__list__item">
               <div class="portal-screen__block__list__item__container">
                 <img src="./public/img/icons-screens/Rectangle-5.svg"/>
               </div>

               <h5 class="portal-screen__block__list__item__title" data-value="Horizon" id="Horizon">Horizon</h5>
             </li>

             <li class="portal-screen__block__list__item">
               <div class="portal-screen__block__list__item__container">
                 <img src="./public/img/icons-screens/Rectangle-6.svg"/>
               </div>

               <h5 class="portal-screen__block__list__item__title" data-value="Maui" id="Maui">Maui</h5>
             </li>

             <li class="portal-screen__block__list__item">
               <div class="portal-screen__block__list__item__container">
                 <img src="./public/img/icons-screens/Rectangle-7.svg"/>
               </div>

               <h5 class="portal-screen__block__list__item__title" data-value="Moderna" id="Moderna">Moderna</h5>
             </li>

             <li class="portal-screen__block__list__item">
               <div class="portal-screen__block__list__item__container">
                 <img src="./public/img/icons-screens/Rectangle-8.svg"/>
               </div>

               <h5 class="portal-screen__block__list__item__title" data-value="Rain" id="Rain">Rain</h5>
             </li>

             <li class="portal-screen__block__list__item">
               <div class="portal-screen__block__list__item__container">
                 <img src="./public/img/icons-screens/Rectangle-9.svg"/>
               </div>

               <h5 class="portal-screen__block__list__item__title" data-value="River Rock" id="River Rock">River Rock</h5>
             </li>

             <li class="portal-screen__block__list__item">
               <div class="portal-screen__block__list__item__container">
                 <img src="./public/img/icons-screens/Rectangle-10.svg"/>
               </div>

               <h5 class="portal-screen__block__list__item__title" data-value="Solid" id="Solid">Solid</h5>
             </li>
           </ul>
        </div>

       <div class="portal-screen__block-color">
         <h4 class="portal-screen__block-color__title" id="color-screen">Color</h4>

         <ul class="portal-screen__block-color__list hide">
           <li class="portal-screen__block-color__list__item">
             <div class="portal-screen__block-color__list__item__container">
               <img src="./public/img/icons-screens/color-black.svg" alt="Black color" />
             </div>
             <h5 class="portal-screen__block-color__list__item__title" data-value="Black" id="Black">Black</h5>
           </li>

           <li class="portal-screen__block-color__list__item">
             <div class="portal-screen__block-color__list__item__container">
               <img src="./public/img/icons-screens/color-white.svg" alt="White color" />
             </div>
             <h5 class="portal-screen__block-color__list__item__title" data-value="White" id="White">White</h5>
           </li>
         </ul>
       </div>

        <span class="portal-screen__remove">Remove</span>
    </div>
        `);

  const icons = $(`
    <div class="icon_container">
       <div class="sun__icon" id="light" data-value="Recessed Lighting">
          <span class="sun__icon__img" id="light-n" style="
              background-image: url(./public/img/icons/sun-black.svg);
          "></span>
       </div>

       <div class="sun__icon screen__icon" id="screen" data-value="Screens">
          <span class="sun__icon__img" id="screen-n" style="
              background-image: url(./public/img/icons/screen.svg);
              background-position: center;
          "></span>
       </div>

       <div class="sun__icon shades__icon" id="shades" data-value="Shades">
          <span class="sun__icon__img" id="shades-n" style="
              background-image: url(./public/img/icons/shades-black.svg);
          "></span>
       </div>

       <div class="sun__icon heaters__icon" id="heaters" data-value="Heaters">
          <span class="sun__icon__img" id="heaters-n" style="
              background-image: url(./public/img/icons/heaters.svg);
          "></span>
       </div>
    </div> 
    `);

  modelId.append(icons);
  mainContent.append(portalContent);

  const buttonPatternMobile = portalContent.find("#pattern");
  const buttonColorMobile = portalContent.find("#color-screen");

  const activeClassNight = "night-mode";
  const activeClassDay = "day-mode";
  const daySwitch = modelId.find("#daySwitch");
  const nightSwitch = modelId.find("#nightSwitch");
  const toggleTime = modelId.find("#js-toggleDayNight");

  const icon = icons.find(".sun__icon");

  const closeButtonLight = mainContent.find(".portal-light__close");
  const portalLight = mainContent.find(".portal-light");
  const activeClassLightIcon = "sun__icon-active--light";
  const removeButtonLight = portalContent.find(".portal-light__remove");

  const portalHeaters = mainContent.find(".portal-heaters");
  const closeButtonHeaters = mainContent.find(".portal-heaters__close");
  const removeButtonHeaters = portalContent.find(".portal-heaters__remove");
  const activeClassHeatersIcon = "sun__icon-active--heaters";

  const portalScreen = mainContent.find(".portal-screen");
  const closeButtonScreen = mainContent.find(".portal-screen__close");
  const removeButtonScreen = mainContent.find(".portal-screen__remove");

  const portalShades = mainContent.find(".portal-shades");
  const closeButtonShades = mainContent.find(".portal-shades__close");
  const removeButtonShades = mainContent.find(".portal-shades__remove");

  const activeClassScreenIcon = "sun__icon-active--screen";
  const activeClassShadesIcon = "sun__icon-active--shades";

  const sunIcon = icons.find("#light");
  const heatersIcon = icons.find("#heaters");
  const screenIcon = icons.find("#screen");
  const shadesIcon = icons.find("#shades");

  const originalSubSystemAdd = state.subSystem.add;
  const originalSubSystemDelete = state.subSystem.delete;

  let tempScreensActive = false;
  let tempShadesActive = false;
  let tempHeatersActive = false;

  state.subSystem.add = function (value) {
    const result = originalSubSystemAdd.call(this, value);

    if (value === typeSubSystem.screen) {
      screenIcon.show();
    } else if (value === typeSubSystem.shades) {
      shadesIcon.show();
    }

    return result;
  };

  state.subSystem.delete = function (value) {
    const result = originalSubSystemDelete.call(this, value);

    if (value === typeSubSystem.screen) {
      screenIcon.hide();
    } else if (value === typeSubSystem.shades) {
      shadesIcon.hide();
    }

    return result;
  };

  //#region INIT TIME SCENE
  if (state.dayMode) {
    toggleTime.removeClass("switch--hight");
    daySwitch.prop("checked", true);
    daySwitch.closest("label").addClass(activeClassDay);
    nightSwitch.closest("label").removeClass(activeClassNight);
    $("body").removeClass("night-mode").addClass("day-mode");

    $("#js-showModalShare").removeClass("share-white");
    $("#js-showModalQRcode").removeClass("ar-white");
    $(".full-screen").removeClass("full-screen-white");
    $(".sun__icon").removeClass("sun__icon--night");
    $("#light-n").removeClass("light-n");
    $("#screen-n").removeClass("screen-n");
    $("#shades-n").removeClass("shades-n");
    $("#heaters-n").removeClass("heaters-n");

    changeSceneTime("Day");
  } else {
    toggleTime.addClass("switch--hight");
    nightSwitch.prop("checked", true);
    nightSwitch.closest("label").addClass(activeClassNight);
    daySwitch.closest("label").removeClass(activeClassDay);
    $("body").removeClass("day-mode").addClass("night-mode");

    $("#js-showModalShare").addClass("share-white");
    $("#js-showModalQRcode").addClass("ar-white");
    $(".full-screen").addClass("full-screen-white");
    $(".sun__icon").addClass("sun__icon--night");
    $("#light-n").addClass("light-n");
    $("#screen-n").addClass("screen-n");
    $("#shades-n").addClass("shades-n");
    $("#heaters-n").addClass("heaters-n");

    changeSceneTime("Night");
  }
  //#endregion

  //#region HANDLE TIME SCENE
  modelId.find('input[name="mode"]').on("change", function () {
    state.dayMode = !state.dayMode;

    const isDay = daySwitch.is(":checked");

    if (isDay) {
      toggleTime.removeClass("switch--hight");
      daySwitch.closest("label").addClass(activeClassDay);
      nightSwitch.closest("label").removeClass(activeClassNight);
      $("body").removeClass("night-mode").addClass("day-mode");

      $("#js-showModalShare").removeClass("share-white");
      $("#js-showModalQRcode").removeClass("ar-white");
      $(".full-screen").removeClass("full-screen-white");
      $(".sun__icon").removeClass("sun__icon--night");
      $("#light-n").removeClass("light-n");
      $("#screen-n").removeClass("screen-n");
      $("#shades-n").removeClass("shades-n");
      $("#heaters-n").removeClass("heaters-n");

      changeSceneTime("Day");
    } else {
      toggleTime.addClass("switch--hight");
      nightSwitch.closest("label").addClass(activeClassNight);
      daySwitch.closest("label").removeClass(activeClassDay);
      $("body").removeClass("day-mode").addClass("night-mode");

      $("#js-showModalShare").addClass("share-white");
      $("#js-showModalQRcode").addClass("ar-white");
      $(".full-screen").addClass("full-screen-white");
      $(".sun__icon").addClass("sun__icon--night");
      $("#light-n").addClass("light-n");
      $("#screen-n").addClass("screen-n");
      $("#shades-n").addClass("shades-n");
      $("#heaters-n").addClass("heaters-n");

      changeSceneTime("Night");
    }
  });
  //#endregion

  //#region ICON LOGIC
  icon.on("click", () => {
    $(".interface-container").hasClass("interface-container-portal")
      ? $(".interface-container").removeClass("interface-container-portal")
      : $(".interface-container").addClass("interface-container-portal");
  });

  //#region HEATERS
  heatersIcon.on("click", () => {
    event.stopPropagation();
    if (state.portalOption === typePortalOption.heaters) {
      closeButtonHeaters.trigger("click");
      setAllHotspotsVisibility(false);
    } else {
      state.portalOption = typePortalOption.heaters;
      state.currentSubSystem = "heaters"; 

      portalLight.hide();
      portalScreen.hide();
      portalShades.hide();
      portalHeaters.show();
      sunIcon.removeClass(activeClassLightIcon);
      heatersIcon.addClass(activeClassHeatersIcon);
      screenIcon.removeClass(activeClassScreenIcon);
      shadesIcon.removeClass(activeClassShadesIcon);
      const heatersIconPos = heatersIcon.offset();
      setSpansHeaters();
      showAvailableSpans();
      setAllHotspotsVisibilityScreen(false);
      setTimeout(() => {
        changeColorForAllScreen();
      }, 0);
      $(".interface-container").addClass("interface-container-portal");
      $("body").addClass("body-hidden");
    }
  });

  removeButtonHeaters.on("click", function () {
    const span = lastHeatersForRemove.last;

    if (!span) return;

    const heaterPosition = `heater_${span.side}_${span.index}`;
    state.electro.delete(heaterPosition);
    changeURL();
    removeSingleHeater(span);

    const hasActiveHeaters = state.currentActiveSpans.some(spanId => spanId.includes("heater"));

    if (!hasActiveHeaters) {
      const $heaterRadio = $('.type_interface_electronic_option[value="Heaters"]');
      $heaterRadio.prop("checked", false)
        .closest('.type_interface_electronic_item')
        .removeClass('type_interface_electronic_item--active');

      state.electro.delete("Heaters");
      $("#heaters").hide();

      if (window.subSystemHelpers && window.subSystemHelpers.updateTextParam) {
        $heaterRadio.closest(".interface__group")
          .find(".interface__group__head__param")
          .text(window.subSystemHelpers.updateTextParam(state, $heaterRadio[0], true, true, true));
      }

      state.currentSubSystem = null;
      state.portalOption = null;
      $("#heaters").removeClass("sun__icon-active--heaters");
    } else {
      state.currentSubSystem = "heaters";
      state.portalOption = "heaters";
      $("#heaters").addClass("sun__icon-active--heaters");

      showAvailableSpans();
      updateHotspots(hotspots);
    }

    portalHeaters.hide();
    closeButtonHeaters.trigger("click");
    $(".interface-container").removeClass("interface-container-portal");
    $("body").removeClass("body-hidden");
  });

  closeButtonHeaters.on("click", () => {
    state.portalOption = "";
    heatersIcon.removeClass(activeClassHeatersIcon);
    portalHeaters.hide();
    setAllHotspotsVisibility(false);
    setAllHotspotsVisibilityScreen(false);
    $(".interface-container").removeClass("interface-container-portal");
    $("body").removeClass("body-hidden");

    const hasActiveHeaters = state.currentActiveSpans.some(span => span.includes("heater"));

    if (!hasActiveHeaters) {
      const $heaterRadio = $('.type_interface_electronic_option[value="Heaters"]');
      $heaterRadio.prop("checked", false)
        .closest('.type_interface_electronic_item')
        .removeClass('type_interface_electronic_item--active');

      state.electro.delete("Heaters");

      $("#heaters").hide();

      if (window.subSystemHelpers && window.subSystemHelpers.updateTextParam) {
        $heaterRadio.closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${window.subSystemHelpers.updateTextParam(state, $heaterRadio[0], true, true, true)}`);
      }
    }
  });

  $('.type_interface_electronic_option[value="Heaters"]').on("change", function () {
    if ($(this).is(":checked")) {
      heatersIcon.trigger("click");
    } else {
      closeButtonHeaters.trigger("click");
    }
  });
  //#endregion

  //#region LIGHT
  sunIcon.on("click", () => {
    event.stopPropagation();
    if (state.portalOption === typePortalOption.light) {
      closeButtonLight.trigger("click");
    } else {
      state.portalOption = typePortalOption.light;
      state.electro.add("Recessed Lighting");

      heatersIcon.removeClass(activeClassHeatersIcon);
      screenIcon.removeClass(activeClassScreenIcon);
      shadesIcon.removeClass(activeClassShadesIcon);
      portalHeaters.hide();
      portalShades.hide();

      sunIcon.addClass(activeClassLightIcon);
      portalLight.show();

      const sunIconPos = sunIcon.offset();

      portalLight.css({
        top: sunIconPos.top,
      });

      setAllHotspotsVisibility(false);
      setAllHotspotsVisibilityScreen(false);
      setTimeout(() => {
        changeColorForAllScreen();
      }, 0);

      $(".interface-container").addClass("interface-container-portal");
      $("body").addClass("body-hidden");
      listenerChange();
    }
  });

  removeButtonLight.on("click", function () {
    portalLight.hide();
    sunIcon.removeClass(activeClassLightIcon);
    state.portalOption = "";

    clearClones(modelForExport, pointLights);

    // $(".type_interface_electronic_item")
    //   .eq(0)
    //   .removeClass("type_interface_electronic_item--active");

    $('.type_interface_electronic_option[value="Recessed Lighting"]').trigger('click');
    $(".interface-container").removeClass("interface-container-portal");
    $("body").removeClass("body-hidden");
  });

  closeButtonLight.on("click", function () {
    state.portalOption = "";

    sunIcon.removeClass(activeClassLightIcon);
    portalLight.hide();

    $(".interface-container").removeClass("interface-container-portal");
    $("body").removeClass("body-hidden");
  });
  //#endregion

  //#region SCREEN
  screenIcon.on("click", function (event) {
    event.stopPropagation();

    if (state.portalOption === typePortalOption.screens) {
      closeButtonScreen.trigger("click");
      setAllHotspotsVisibilityScreen(false);
    } else {
      state.portalOption = typePortalOption.screens;

      portalHeaters.hide();
      portalLight.hide();
      portalShades.hide();

      sunIcon.removeClass(activeClassLightIcon);
      heatersIcon.removeClass(activeClassHeatersIcon);
      shadesIcon.removeClass(activeClassShadesIcon);

      screenIcon.addClass(activeClassScreenIcon);

      const screenIconPos = screenIcon.offset();

      portalScreen.show();

      setSpansScreen();
      showAvailableSpansScreen();
      setAllHotspotsVisibility(false);

      setTimeout(() => {
        changeColorForAllScreen();
      }, 0);

      $(".interface-container").addClass("interface-container-portal");
      $("body").addClass("body-hidden");
    }
  });

  closeButtonScreen.on("click", function () {
    state.portalOption = "";
    screenIcon.removeClass(activeClassScreenIcon);
    portalScreen.hide();
    setAllHotspotsVisibilityScreen(false);
    setAllHotspotsVisibility(false);

    $(".interface-container").removeClass("interface-container-portal");
    $("body").removeClass("body-hidden");
  });

  removeButtonScreen.on("click", function () {
    if (!lastScreenForRemove.last) return;

    const span = lastScreenForRemove.last;
    const currentId = $(span.hotspot.element).get(0).id;
    const baseId = getBaseSpanId(currentId);

    state.currentActiveSpans = state.currentActiveSpans.filter(
      (spanId) => getBaseSpanId(spanId) !== baseId
    );

    $(span.hotspot.element).get(0).id = baseId;

    span.isScreen = false;
    span.columns?.forEach((column) => (column.visible = false));
    span.prepareScreensZ?.forEach((data) => {
      data.screen.visible = false;
      data.screen.children.forEach((child) => {
        child.visible = false;
      });
    });
    span.prepareScreens?.forEach((data) => {
      data.screen.visible = false;
      data.screen.children.forEach((child) => {
        child.visible = false;
      });
    });

    const hasActiveScreens = state.currentActiveSpans.some(span => span.includes("**SC"));

    if (!hasActiveScreens) {
      state.subSystem.delete("Screens");
      if (window.subSystemHelpers) {
        window.subSystemHelpers.getSubSystemElement('screens')
          .removeClass(window.subSystemHelpers.activeStyleSubSystem);
      }
      const $screenRadio = $('.type_interface_subSystem_option[data-subsystem="screens"]');
      if ($screenRadio.length > 0) {
        $screenRadio.prop("checked", false);
        $("#screen").hide();

        if (window.subSystemHelpers && window.subSystemHelpers.updateTextParam) {
          $screenRadio.closest(".interface__group")
            .find(".interface__group__head__param")
            .text(`${window.subSystemHelpers.updateTextParam(state, $screenRadio[0], true, true, true)}`);
        }
      } else {
        console.log("Screens radio button not found!");
      }
    }

    setSpansScreen();
    portalScreen.hide();
    closeButtonScreen.trigger("click");
    $(".interface-container").removeClass("interface-container-portal");
    $("body").removeClass("body-hidden");
  });
  //#endregion

  //#region SHADES
  shadesIcon.on("click", function (event) {
    event.stopPropagation();

    if (state.portalOption === typePortalOption.shades) {
      closeButtonShades.trigger("click");
      setAllHotspotsVisibilityScreen(false);
    } else {
      state.portalOption = typePortalOption.shades;

      portalHeaters.hide();
      portalScreen.hide();
      portalLight.hide();

      sunIcon.removeClass(activeClassLightIcon);
      heatersIcon.removeClass(activeClassHeatersIcon);
      screenIcon.removeClass(activeClassScreenIcon);

      shadesIcon.addClass(activeClassShadesIcon);
      portalShades.show();

      // ADD THESE LINES ↓
      setTimeout(() => {
        portalShades[0].scrollIntoView({
          behavior: "smooth",
          block: "end"
        });
      }, 100);
      // ADD THESE LINES ↑

      showAvailableSpansScreen();
      setAllHotspotsVisibility(false);

      setTimeout(() => {
        changeColorForAllScreen();
      }, 0);

      $(".interface-container").addClass("interface-container-portal");
      $("body").addClass("body-hidden");
    }
  });

  closeButtonShades.on("click", () => {
    state.portalOption = "";
    shadesIcon.removeClass(activeClassShadesIcon);
    portalShades.hide();

    setAllHotspotsVisibilityScreen(false);
    setAllHotspotsVisibility(false);

    $(".interface-container").removeClass("interface-container-portal");
    $("body").removeClass("body-hidden");
  });

  removeButtonShades.on("click", function () {
    if (!lastScreenForRemove.last) return;

    const span = lastScreenForRemove.last;
    const currentId = $(span.hotspot.element).get(0).id;
    const baseId = getBaseSpanId(currentId);

    state.currentActiveSpans = state.currentActiveSpans.filter(
      (spanId) => getBaseSpanId(spanId) !== baseId
    );

    $(span.hotspot.element).get(0).id = baseId;

    span.isShades = false;
    span.prepareShadesZ?.forEach((data) => {
      data.shadeZ.visible = false;
      data.shadeZ.children.forEach((child) => {
        child.visible = false;
      });
    });
    span.prepareShades?.forEach((data) => {
      data.shade.visible = false;
      data.shade.children.forEach((child) => {
        child.visible = false;
      });
    });

    const hasActiveShades = state.currentActiveSpans.some(span => span.includes("**SH"));

    if (!hasActiveShades) {
      state.subSystem.delete("Shades");
      if (window.subSystemHelpers) {
        window.subSystemHelpers.getSubSystemElement('shades')
          .removeClass(window.subSystemHelpers.activeStyleSubSystem);
      }
      const $shadesRadio = $('.type_interface_subSystem_option[data-subsystem="shades"]');

      if ($shadesRadio.length > 0) {
        $shadesRadio.prop("checked", false);
        $("#shades").hide();

        if (window.subSystemHelpers && window.subSystemHelpers.updateTextParam) {
          $shadesRadio.closest(".interface__group")
            .find(".interface__group__head__param")
            .text(`${window.subSystemHelpers.updateTextParam(state, $shadesRadio[0], true, true, true)}`);
        }
      } else {
        console.log("Shades radio button not found!");
      }
    }

    setSpansScreen();
    changeColorForAllScreen();
    portalShades.hide();
    closeButtonShades.trigger("click");
    $(".interface-container").removeClass("interface-container-portal");
    $("body").removeClass("body-hidden");
  });
  //#endregion

  //#region LOGIC PORTAL SCREEN
  const activeClassPattern = "portal-screen__block__list__item--active";
  const activeClassColor = "portal-screen__block-color__list__item--active";

  const buttonsPattern = portalScreen.find(".portal-screen__block__list__item");
  const colorsButtons = portalScreen.find(
    ".portal-screen__block-color__list__item"
  );

  //#region PATTERN
  //#region INIT INPUT
  buttonsPattern.removeClass(activeClassPattern);

  buttonsPattern.each(function () {
    const buttonTitle = $(this)
      .find(".portal-screen__block__list__item__title")
      .text();

    if (buttonTitle === state.patternScreen) {
      $(this).addClass(activeClassPattern);
    }
  });
  //#endregion

  //#region HANDLE INPUT
  buttonsPattern.on("click", function () {
    const inputValue = $(this)
      .find(".portal-screen__block__list__item__title")
      .text();
    state.patternScreen = inputValue;

    buttonsPattern.removeClass(activeClassPattern);

    buttonsPattern.each(function () {
      const buttonTitle = $(this)
        .find(".portal-screen__block__list__item__title")
        .text();
      if (buttonTitle === state.patternScreen) {
        $(this).addClass(activeClassPattern);
      }
    });

    listenerChange();
    changeColorForAllScreen();
  });
  //#endregion
  //#endregion

  //#region COLORS
  //#region INIT INPUT
  colorsButtons.removeClass(activeClassColor);

  colorsButtons.each(function () {
    const buttonTitle = $(this)
      .find(".portal-screen__block-color__list__item__title")
      .text();
    if (buttonTitle === state.colorScreen) {
      $(this).addClass(activeClassColor);
    }
  });
  //#endregion

  //#region HANDLE INPUT
  colorsButtons.on("click", function () {
    const inputValue = $(this)
      .find(".portal-screen__block-color__list__item__title")
      .text();
    state.colorScreen = inputValue;
    listenerChange();

    colorsButtons.removeClass(activeClassColor);

    colorsButtons.each(function () {
      const buttonTitle = $(this)
        .find(".portal-screen__block-color__list__item__title")
        .text();
      if (buttonTitle === state.colorScreen) {
        $(this).addClass(activeClassColor);
      }
    });

    changeColorForAllScreen();
  });
  //#endregion
  //#endregion
  //#endregion

  //#region MOBILE LOGIC SCREEN
  buttonPatternMobile.on("click", (e) => {
    e.stopPropagation();
    console.log("click");
    $(".portal-screen__block__list").addClass("visible");
    $(".portal-screen__block__title").addClass("active");
    $(".portal-screen__block__list").removeClass("hide");
    $(".portal-screen__block-color__list").removeClass("visible");
    $(".portal-screen__block-color__list").addClass("hide");
    $(".portal-screen__block-color__title").removeClass("active");


  });

  buttonColorMobile.on("click", (e) => {
    e.stopPropagation();
    $(".portal-screen__block-color__list").addClass("visible");
    $(".portal-screen__block-color__title").addClass("active");
    $(".portal-screen__block-color__list").removeClass("hide");
    $(".portal-screen__block__list").removeClass("visible");
    $(".portal-screen__block__list").addClass("hide");
    $(".portal-screen__block__title").removeClass("active");
  });
  //#endregion

  //light range
  const customRange = generateRangeHTML(lightRange[0]);
  const customRangeShades = generateRangeHTML(shadesRange[0]);
  const rangeContainer = mainContent.find(".portal-light__range");
  const rangeContainerShades = mainContent.find(".portal-shades__range");

  rangeContainer.append(customRange);
  rangeContainerShades.append(customRangeShades);

  portalLight.hide();
  portalHeaters.hide();
  portalScreen.hide();
  portalShades.hide();

  icon.hide();


  if (state.subSystem.has("Screens")) {
    screenIcon.show();
    if (state.portalOption === typePortalOption.screens) {
      screenIcon.addClass(activeClassScreenIcon);
    }
  }

  if (state.subSystem.has("Shades")) {
    shadesIcon.show();
    if (state.portalOption === typePortalOption.shades) {
      shadesIcon.addClass(activeClassShadesIcon);
    }
  }


  if (state.electro && state.electro.size > 0 && !window.heatersRestored) {
    window.heatersRestored = true;

    if (state.electro.has("Heaters")) {
      heatersIcon.show();
    }

    const heaterPositions = [];
    state.electro.forEach(id => {
      if (typeof id === 'string' && id.startsWith('heater_') && id !== 'Heaters') {
        heaterPositions.push(id);
      }
    });

    if (heaterPositions.length > 0) {
      setSpansHeaters();

      heaterPositions.forEach(heaterPos => {
        const parts = heaterPos.split('_');
        const side = parts[1];
        const idx = parseInt(parts[2]);

        const span = spansHeaters.find(s =>
          s.side === side && s.index === idx
        );

        if (span && span.heaters) {
          span.isHeater = true;
          span.active = false;
          span.heaters.visible = true;
          span.heaters.children.forEach(child => {
            child.visible = true;
          });

          const spanId = $(span.hotspot.element).get(0).id;
          if (!state.currentActiveSpans.includes(spanId)) {
            state.currentActiveSpans.push(spanId);
          }
        }
      });

      if (state.portalOption === typePortalOption.heaters) {
        heatersIcon.addClass(activeClassHeatersIcon);
        portalHeaters.show();
      }
    }
  }

  window.screenIcon = screenIcon;
  window.shadesIcon = shadesIcon;
  window.closeButtonScreen = closeButtonScreen;
  window.closeButtonShades = closeButtonShades;

  const originalAdd = state.subSystem.add.bind(state.subSystem);
  const originalDelete = state.subSystem.delete.bind(state.subSystem);

  state.subSystem.add = function (value) {
    const result = originalAdd(value);

    // Show icon when subsystem is added
    if (value === "Screens") {
      screenIcon.show();
    } else if (value === "Shades") {
      shadesIcon.show();
    }

    return result;
  };

  state.subSystem.delete = function (value) {
    const result = originalDelete(value);

    // Hide icon - if subsystem is removed
    if (value === "Screens") {
      screenIcon.hide();
      screenIcon.removeClass(activeClassScreenIcon);
    } else if (value === "Shades") {
      shadesIcon.hide();
      shadesIcon.removeClass(activeClassShadesIcon);
    }

    return result;
  };

  $(document).on("click", function (event) {
    const target = $(event.target);

    if (target.closest("#ar_model_view").length ||
      target.closest("#ar_model_viewer").length ||
      target.is("canvas")) {
      return;
    }

    const isMobile = window.innerWidth <= 1024;

    if (isMobile) {
      return;
    }

    if (portalLight.is(":visible") &&
      !target.closest(".portal-light").length &&
      !target.closest("#light").length) {
      closeButtonLight.trigger("click");
    }

    if (portalHeaters.is(":visible") &&
      !target.closest(".portal-heaters").length &&
      !target.closest("#heaters").length) {
      closeButtonHeaters.trigger("click");
    }

    if (portalScreen.is(":visible") &&
      !target.closest(".portal-screen").length &&
      !target.closest("#screen").length &&
      !target.closest(".hotspot").length) {
      closeButtonScreen.trigger("click");
    }

    if (portalShades.is(":visible") &&
      !target.closest(".portal-shades").length &&
      !target.closest("#shades").length &&
      !target.closest(".hotspot").length) {
      closeButtonShades.trigger("click");
    }
  });


  return { portal: portalLight, sunIcon };
}
